import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  let levelName = "";
  if (currentLevel === "national") {
    levelName = "Nasional";
  } else if (currentLevel === "province") {
    levelName = "Provinsi";
  } else if (currentLevel === "district") {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tr style={{ border: "none", padding: 0 }}>
          <th style={{ border: "none", paddingBottom: "0" }}>
            <h3>SISMAL v3, KINERJA KADER</h3>
          </th>
        </tr>
      </table>
      <table>
        <tr style={{ border: "none" }}>
          <th
            width="200"
            style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
          >
            Periode Laporan
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {periodeName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Tanggal
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {reportInfo?.dateStart} - {reportInfo?.dateEnd}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Level
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            : {levelName}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Provinsi
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.province
              ? "Semua Provinsi"
              : reportInfo?.province?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            Kab/Kota
          </th>
          <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
            :{" "}
            {!reportInfo?.district
              ? "Semua Kab/Kota"
              : reportInfo?.district?.split("|")[1]}
          </th>
        </tr>
        <tr style={{ border: "none" }}>
          <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
          <th style={{ border: "none", paddingTop: 0 }}>
            : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
          </th>
        </tr>
      </table>
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Provinsi</th>
            <th>Kab/Kota</th>
            <th>Fasyankes</th>
            <th>Nama</th>
            <th>Tahun</th>
            <th>Bulan</th>
            <th>Logistik RDT malaria yang diterima kader</th>
            <th>Target Penemuan / Pemeriksaan Oleh Kader</th>
            <th>Total Rumah yang menjadi tanggung jawab kader</th>
            <th>Jumlah Rumah yang Dikunjungi satu kali dalam bulan ini</th>
            <th>Jumlah Rumah yang Dikunjungi dua kali dalam bulan ini</th>
            <th>Jumlah total kunjungan rumah</th>
            <th>Jumlah pemeriksaan kader dalam bulan ini</th>
            <th>Keaktifan berdasarkan target pemeriksaan</th>
            <th>Jumlah Suspek</th>
            <th>Jumlah sasaran survey kontak serumah</th>
            <th>
              {[UserLevel.SR, UserLevel.SSR].includes(currentLevel)
                ? "Keaktifan Kader"
                : "Keaktifan berdasarkan target kunjungan rumah (Otomatis)"}{" "}
            </th>
          </tr>
        </thead>
        <tbody>
          {reportsData.length !== 0 ? (
            reportsData?.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item?.province}</td>
                <td>{item?.district}</td>
                <td>{item?.fasyankes}</td>
                <td>{item?.name}</td>
                <td>{item?.year}</td>
                <td>{monthConverter(item?.month)}</td>
                <td>{item?.logistic_receive}</td>
                <td>{item?.target_cadre_inspection}</td>
                <td>{item?.total_house_responsibility}</td>
                <td>{item?.total_house_visited_one_month}</td>
                <td>{item?.total_house_visited_two_month}</td>
                <td>{item?.total_house_visited}</td>
                <td>{item?.total_cadre_inspection}</td>
                <td>{item?.cadre_active_by_cadre_inspection}</td>
                <td>{item?.total_suspect}</td>
                <td>{item?.total_survei_target}</td>
                <td>{item?.cadre_active}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={11}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
